import React from "react";
import { Link } from "react-router-dom";
import { useMembership } from "../lib/MembershipContext";

// Small membership crest: reinforces "where am I in my Kingdom journey?" and links to /membership.
// Subtle per-tier color; no animation/sales-pitch. Explorer=sky, Adventurer=purple, Royalty=gold.
const TIER_STYLES = {
  explorer: { emoji: "🏰", label: "Explorer", cls: "bg-white/95 text-[#1F6FA8] border-[#2F9BE0]/45 shadow-sm", title: "Kingdom Explorer — join the Kingdom" },
  adventurer: { emoji: "🛡️", label: "Adventurer", cls: "bg-white/95 text-[#7A3CB3] border-purpleK/40 shadow-sm", title: "Kingdom Adventurer — see Royalty benefits" },
  royalty: { emoji: "👑", label: "Royalty", cls: "bg-[#FFF6D6] text-[#7A5A00] border-goldK/60 shadow-sm", title: "Kingdom Royalty — your membership" },
};

export default function MembershipBadge({ className = "", full = false }) {
  const { access } = useMembership();
  const t = TIER_STYLES[access.level] || TIER_STYLES.explorer;
  return (
    <Link to="/membership" title={t.title} data-testid={`membership-badge-${access.level}`}
      className={`inline-flex items-center gap-1.5 rounded-full border ${t.cls} font-display font-bold ${full ? "px-3.5 py-2 text-sm w-full justify-center" : "px-2.5 py-1.5 text-[13px]"} hover:brightness-95 transition focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#7A3CB3]/80 focus-visible:ring-offset-2 ${className}`}>
      <span aria-hidden>{t.emoji}</span>
      <span className={full ? "" : "hidden lg:inline"}>{t.label}</span>
    </Link>
  );
}
